export const ACCESS_CONTROL_TEXT = {
  // Access Control Page
  TITLE: 'Access Control',
  SEARCH_LABEL: 'Search',
  ADD_NEW: 'Add New',
  VENDOR_NAME: 'Vendor Name',
  POINT_OF_CONTACT: 'Point of Contact',
  EMAIL: 'Email',
  CONTACT: 'Contact',
  STATUS: 'Status',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  CONFIRM_TITLE: 'Confirm Status Change',
  CONFIRM_MESSAGE: 'Are you sure you want to change the status?',
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  NO_DATA: 'No data found',
  SUCCESS_UPDATE: 'Status updated successfully',
  ERROR_UPDATE: 'Failed to update status',

  // Add Vendor POC Dialog
  ADD_VENDOR_TITLE: 'Add New Vendor',
  ADD_VENDOR_SUBTITLE: 'Create a new vendor account and configure their access permissions',
  VENDOR_REP_LABEL: 'Vendor Rep',
  VENDOR_ACCESS_LABEL: 'Vendor Access',
  ISKILL_ACCESS_LABEL: 'iSkill Access',
  YES: 'Yes',
  NO: 'No',
  SUBMIT: 'Submit',
  REQUIRED: 'is required.',
  INVALID_EMAIL: 'Invalid email format.',
  EMAIL_EXISTS: 'Email already exists.',
  CONTACT_NUMERIC: 'Contact must be numeric.',
};
